import { render, staticRenderFns } from "./edit-customer.vue?vue&type=template&id=54fa03d6&scoped=true"
import script from "./edit-customer.vue?vue&type=script&lang=js"
export * from "./edit-customer.vue?vue&type=script&lang=js"
import style0 from "./edit-customer.vue?vue&type=style&index=0&id=54fa03d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fa03d6",
  null
  
)

export default component.exports